const REG_UNL = '87 Reg Unl';
const MID_UNL = '89 Mid Unl';
const PREM_91 = '91 Prem Unl';
const PREM_92 = '92 Prem Unl';

const REG_BG = '#455A64';
const MID_BG = '#303F9F';
const PREM_BG = '#D32F2F';
const DSL_BG = '#689F38';
const ETOH_BG = '#FFA000';
const BD_BG = '#5D4037';
const OTHER_BG = '#616161';
const ADD_BG = '##0097A7';

export const commodityCodeToDisplay = {
	'87BRND': { abbr: REG_UNL, bg: REG_BG },
	'87NEAT': { abbr: REG_UNL, bg: REG_BG },
	'87REG10': { abbr: REG_UNL, bg: REG_BG },
	'87UNBRND': { abbr: REG_UNL, bg: REG_BG },

	'89BRND': { abbr: MID_UNL, bg: MID_BG },
	'89MID10': { abbr: MID_UNL, bg: MID_BG },
	'89UNBRND': { abbr: MID_UNL, bg: MID_BG },

	'91BRND': { abbr: PREM_91, bg: PREM_BG },
	'91PRE10': { abbr: PREM_91, bg: PREM_BG },
	'91UNBRND': { abbr: PREM_91, bg: PREM_BG },

	'92BRND': { abbr: PREM_92, bg: PREM_BG },
	'92NEAT': { abbr: PREM_92, bg: PREM_BG },
	'92PRE10': { abbr: PREM_92, bg: PREM_BG },
	'92UNBRND': { abbr: PREM_92, bg: PREM_BG },

	B100CLR: { abbr: 'B100', bg: BD_BG },
	B20CLEAR: { abbr: 'B20', bg: BD_BG },
	B5CLEAR: { abbr: 'B5', bg: BD_BG },
	B99CLEAR: { abbr: 'B99', bg: BD_BG },

	R95: { abbr: 'R95', bg: BD_BG },
	R99: { abbr: 'R99', bg: BD_BG },
	R99B20: { abbr: 'R99/B20', bg: BD_BG },
	RD80B20: { abbr: 'RD80/B20', bg: BD_BG },

	E85: { abbr: 'E85', bg: ETOH_BG },
	ETHANOL: { abbr: 'ETOH', bg: ETOH_BG },

	'LSDCLR ': { abbr: 'Clr Diesel (500 PPM)', bg: DSL_BG },
	ULSDCL: { abbr: 'Diesel', bg: DSL_BG },
	ULSDRED: { abbr: 'Red Diesel', bg: DSL_BG },

	ADD: { abbr: 'Additive', bg: ADD_BG },
	RACKSERV: { abbr: 'Rack Service', bg: OTHER_BG },
	STOP: { abbr: 'Stop', bg: OTHER_BG },
	STOVEOIL: { abbr: 'Stove Oil', bg: OTHER_BG },
	TRANSMIX: { abbr: 'Transmix', bg: OTHER_BG },
	UNKNOWN: { abbr: 'UNK', bg: OTHER_BG },
};

export function getCommodityCodeToDisplay(cmdCode) {
	if (commodityCodeToDisplay[cmdCode]) {
		return commodityCodeToDisplay[cmdCode];
	} else {
		return { abbr: cmdCode, bg: OTHER_BG };
	}
}
